export const canonicalUrl = process.env.REACT_APP_BASE_MAIN_URL?.slice(0, -1);
